<template>
  <div class="bottombar">
    <van-tabbar v-model="active" :fixed="false" route :before-change="beforeChange" @change="onChange">
      <template v-for="(item,index) in tabBars">
        <van-popover v-model="showMetaPopover" v-if="index===3" :offset="[0,20]" placement="top">
          <div>
            <div class="van-popover__action">
              <div class="van-popover__action-text van-hairline--bottom">OMC</div>
            </div>
            <div class="van-popover__action">
              <div class="van-popover__action-text van-hairline--bottom">ALADIN</div>
            </div>
            <div class="van-popover__action">
              <div class="van-popover__action-text van-hairline--bottom">Game</div>
            </div>
            <div class="van-popover__action">
              <div class="van-popover__action-text van-hairline--bottom">Website</div>
            </div>
          </div>
          <template #reference>
            <van-tabbar-item :key="item.name" :badge="item.badge" :dot="item.isShowRedDot" :to="item.name" replace>
              <span>{{ item.text }}</span>
              <template #icon="props">
                <img :src="props.active ? item.selectedIconPath : item.iconPath" alt="icon" class="img_icon"/>
              </template>
            </van-tabbar-item>
          </template>
        </van-popover>
        <van-popover v-model="showMorePopover" v-else-if="index===4" :offset="[0,20]" placement="top">
          <div>
            <div class="van-popover__action">
              <div class="van-popover__action-text van-hairline--bottom">{{ $t('message.mallHeader.Cooperate') }}</div>
            </div>
            <div class="van-popover__action">
              <div class="van-popover__action-text van-hairline--bottom">{{ $t('message.mallHeader.Guide') }}</div>
            </div>
          </div>
          <template #reference>
            <van-tabbar-item :key="item.name"
                             :badge="item.badge"
                             :dot="item.isShowRedDot"
                             :to="item.name"
                             replace>
              <span>{{ item.text }}</span>
              <template #icon="props">
                <img :src="props.active ? item.selectedIconPath : item.iconPath" alt="icon" class="img_icon"/>
              </template>
            </van-tabbar-item>
          </template>
        </van-popover>
        <van-tabbar-item v-else :key="item.name"
                         :badge="item.badge"
                         :dot="item.isShowRedDot"
                         :to="item.name"
                         replace>
          <span>{{ item.text }}</span>
          <template #icon="props">
            <img :src="props.active ? item.selectedIconPath : item.iconPath" alt="icon" class="img_icon"/>
          </template>
        </van-tabbar-item>
      </template>
    </van-tabbar>
  </div>
</template>

<script>
const settingConfig = require('../../settings.js');

export default {
  name: 'bottombar',
  props: {
    // 选中tabbar
    selected: { type: Number, default: 0 },
    // 默认颜色
    color: { type: String, default: "#777" },
    // 选中颜色
    selectedColor: { type: String, default: "#FFC801" },
    //item数组
    tabBars: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      active: 0,
      showMetaPopover: false,
      showMorePopover: false,
    };
  },
  methods: {
    beforeChange(index) {
      let isCanModify = true;
      if (index === 2) {
        const openUrl = settingConfig.infoMarket;
        window.open(openUrl);
        // this.showMetaPopover = true;
        isCanModify = false;
      }else if (index === 3) {
        // this.showMetaPopover = true;
        isCanModify = false;
      } else if (index === 4) {
        //this.showMorePopover = true;
        isCanModify = false;
      }
      return isCanModify;
    },
    onChange(index) {
      this.active = index;
    },
  },
};
</script>


<style lang="scss" scoped>

.van-tabbar {
  height: vw(100) !important;
  background-color: #000;
}

.van-tabbar-item {
  font-size: vw(23) !important;
  background-color: #000;
  color: #777;
}

.van-tabbar-item--active {
  background-image: linear-gradient(270deg, #FFC801 0%, #FF7C01 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.van-popover__wrapper {
  flex: 1;
  display: flex;
}

::v-deep .van-popover__action {
  width: vw(140);
  font-family: PingFangHK;
  font-size: vw(20);
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: var(--black);
}

.img_icon {
  margin-bottom: 4px;
  width: vw(36);
  height: vw(36);
}
</style>